import { Box, Grid, TextField, Autocomplete, Typography, Container, IconButton, Button, InputLabel, CircularProgress, Backdrop, Switch } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { ArrowBack as ArrowBackIcon, Save as SaveIcon, Clear as ClearIcon } from '@mui/icons-material'
import { useNavigate, useParams } from 'react-router'
import { useUtiles } from '../../../../shared/context/utilesContext'
import SelectLocationComponent from '../../components/SelectLocationComponent'
import SelectClassificationComponent from '../../components/SelectClassificationComponent'
import { useForm, Controller } from 'react-hook-form'
import { useLocations } from '../../../../shared/context/locationsContext'
import { useEffect } from 'react'
import { useAbility } from '../../../../shared/context/AbilityContext'


export default function CreateUpdatelocationView() {
    const hash = useParams().hash
    const navigate = useNavigate()

    const ability = useAbility();
    useEffect(() => {
        if (!ability.can('create', 'ASSETS.LOCATIONS') && !ability.can('update', 'ASSETS.LOCATIONS')) {
            navigate('/')
        }
    }, [ability])

    const { createLocation, 
        loadingCreateLocation, 
        location, 
        setLocation, 
        setSelectLocationParent, 
        setSelectClassification1, 
        setSelectClassification2,
        loadingUpdateLocation,
        updateLocation,
        resetLocation,
        getLocationByHash,
        loadingGetLocationByHash
    } = useLocations()

    const theme = useTheme()

    const { register, control, handleSubmit, formState: { errors }, setValue, watch } = useForm({
        defaultValues: {
            parent: null,
            name: '',
            code: '',
            description: '',
            city: '',
            state: '',
            country: '',
            classification1: null,
            classification2: null,
            enabled: true,
        }
    })

    const handleFieldChange = (field, value) => {
        setLocation({ ...location, [field]: value })
        setValue(field, value)
    }

    const handleClearClassification = (field) => {
        setLocation({ ...location, [field]: null })
        setValue(field, null)
    }

    const { toogleOpenSilder, locationString } = useUtiles()


    const handleCreateUpdateLocation = async () => {
        if (location.id) {
            await updateLocation()
        } else {
            await createLocation()
        }
    }


    // Si existe hash en la url (usar router), obtener la localización
    useEffect(() => {
        if (hash) {
            getLocationByHash(hash)
        }
    }, [hash])

    

    useEffect(() => {
        if (location.id) {
            setValue('parent', location.parent)
            setValue('name', location.name)
            setValue('code', location.code)
            setValue('description', location.description)
            setValue('city', location.city)
            setValue('state', location.state)
            setValue('country', location.country)
            setValue('classification1', location.classification1)
            setValue('classification2', location.classification2)
        }
    }, [location])

   

    return (
        <Container maxWidth="xl" sx={{
            padding: '0px', margin: '0px',
        }}>
            <form onSubmit={handleSubmit(handleCreateUpdateLocation)}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px'
                }}>
                    <IconButton
                        onClick={() => navigate('/activos/ubicaciones')}
                        sx={{
                            borderRadius: '12px',
                            padding: '8px',
                            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                            transition: 'all 0.2s',
                            "&:hover": {
                                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>

                    <Button
                        variant="contained"
                        startIcon={<SaveIcon />}
                        type='submit'
                        sx={{
                            borderRadius: '8px',
                            padding: '8px 25px',
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            borderRadius: '50px',
                            transition: 'all 0.2s',
                            
                            "&:hover": {
                                backgroundColor: theme.palette.primary.dark,
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        Guardar
                    </Button>
                </Box>


                <Box sx={{
                    borderRadius: '10px',
                    backgroundColor: theme.palette.background.paper,
                    padding: '20px',
                    position: 'relative'
                }}>


                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>


                        <Typography variant="h6" sx={{
                            fontWeight: 'bold',
                            marginBottom: '20px',
                            fontSize: '20px',
                        }}>
                            {location.id ? 'Editar Ubicación' : 'Crear Ubicación'}
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '10px' }}>
                        <Grid container spacing={2} columns={12}>
                            <Grid item size={{ xs: 12 }}>
                                <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Ubicación</InputLabel>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }} >
                                    Seleccione la ubicación jerárquica superior a la que estará vinculada esta localización
                                </Typography>
                                <Controller
                                    control={control}
                                    name="parent"
                                    render={({ field }) => (
                                        <Box sx={{ position: 'relative', width: '100%' }}>
                                            <TextField fullWidth placeholder="Seleccione la ubicación padre" slotProps={{ input: { readOnly: true } }}
                                                onClick={() => toogleOpenSilder(() => <SelectLocationComponent setSelectLocationParent={setSelectLocationParent} />, 500, 'Seleccionar ubicación')}
                                                value={locationString(location[field.name]) || ''}
                                                onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                            />
                                            {location[field.name] && (
                                                <IconButton 
                                                    size="small"
                                                    onClick={() => handleClearClassification(field.name)}
                                                    sx={{ 
                                                        position: 'absolute', 
                                                        right: '8px', 
                                                        top: '50%', 
                                                        transform: 'translateY(-50%)',
                                                        zIndex: 2
                                                    }}
                                                >
                                                    <ClearIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                        </Box>
                                    )}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Nombre <span style={{ color: 'red' }}>*</span></InputLabel>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                                    Denominación principal que identificará esta ubicación en el sistema
                                </Typography>
                                <Controller
                                    control={control}
                                    name="name"
                                    rules={{ required: "El nombre es requerido" }}
                                    render={({ field }) => (
                                        <TextField fullWidth placeholder="Ingrese el nombre" {...field} error={!!errors.name} helperText={errors.name?.message} 
                                        value={location[field.name]}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)} />
                                    )}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Código</InputLabel>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                                    Identificador alfanumérico único para referenciar esta ubicación
                                </Typography>
                                <Controller
                                    control={control}
                                    name="code"
                                    render={({ field }) => (
                                        <TextField fullWidth placeholder="Ingrese el código" {...field} 
                                        value={location[field.name]}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)} />
                                    )}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Descripción</InputLabel>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                                    Detalle adicional que caracteriza o especifica la naturaleza de esta ubicación
                                </Typography>
                                <Controller
                                    control={control}
                                    name="description"
                                    render={({ field }) => (
                                        <TextField fullWidth placeholder="Ingrese la descripción" {...field} 
                                        value={location[field.name]}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)} />
                                    )}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Ciudad</InputLabel>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                                    Centro urbano donde se encuentra físicamente esta ubicación
                                </Typography>
                                <Controller
                                    control={control}
                                    name="city"
                                    render={({ field }) => (
                                        <TextField fullWidth placeholder="Ingrese la ciudad" {...field} 
                                        value={location[field.name]}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)} />
                                    )}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}  >Departamento</InputLabel>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                                    División territorial administrativa a la que pertenece esta ubicación
                                </Typography>
                                <Controller
                                    control={control}
                                    name="state"
                                    render={({ field }) => (
                                        <TextField fullWidth placeholder="Ingrese el departamento" {...field} 
                                        value={location[field.name]}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)} />
                                    )}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>País</InputLabel>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                                    Nación o territorio soberano donde se encuentra esta ubicación
                                </Typography>
                                <Controller
                                    control={control}
                                    name="country"
                                    render={({ field }) => (
                                        <TextField fullWidth placeholder="Ingrese el país" {...field} 
                                        value={location[field.name]}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)} />
                                    )}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Clasificación 1</InputLabel>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                                    Categoría primaria para organizar y filtrar ubicaciones según su tipología
                                </Typography>
                                <Controller
                                    control={control}
                                    name="classification1"
                                    render={({ field }) => (
                                        <Box sx={{ position: 'relative', width: '100%' }}>
                                            <TextField fullWidth placeholder="Ingrese la clasificación 1" 
                                            onClick={() => toogleOpenSilder(() => <SelectClassificationComponent type_asset='locations' number={1} setSelectClassification={setSelectClassification1}/>, 500, 'Seleccionar clasificación')} 
                                            value={location[field.name]?.value || ''}
                                            onChange={(e) => handleFieldChange(field.name, e.target.value)} />
                                            {location[field.name] && (
                                                <IconButton 
                                                    size="small"
                                                    onClick={() => handleClearClassification(field.name)}
                                                    sx={{ 
                                                        position: 'absolute', 
                                                        right: '8px', 
                                                        top: '50%', 
                                                        transform: 'translateY(-50%)',
                                                        zIndex: 2
                                                    }}
                                                >
                                                    <ClearIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                        </Box>
                                    )}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Clasificación 2</InputLabel>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                                    Categoría secundaria que complementa la clasificación principal de esta ubicación
                                </Typography>
                                <Controller
                                    control={control}
                                    name="classification2"
                                    render={({ field }) => (
                                        <Box sx={{ position: 'relative', width: '100%' }}>
                                            <TextField fullWidth placeholder="Ingrese la clasificación 2" 
                                            onClick={() => toogleOpenSilder(() => <SelectClassificationComponent type_asset='locations' number={2} setSelectClassification={setSelectClassification2} />, 500, 'Seleccionar clasificación')} 
                                            value={location[field.name]?.value || ''}
                                            onChange={(e) => handleFieldChange(field.name, e.target.value)} />
                                            {location[field.name] && (
                                                <IconButton 
                                                    size="small"
                                                    onClick={() => handleClearClassification(field.name)}
                                                    sx={{ 
                                                        position: 'absolute', 
                                                        right: '8px', 
                                                        top: '50%', 
                                                        transform: 'translateY(-50%)',
                                                        zIndex: 2
                                                    }}
                                                >
                                                    <ClearIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                        </Box>
                                    )}
                                />
                            </Grid>


                            <Grid item size={{ xs: 12 }}>
                                <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>Habilitado</InputLabel>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 1, display: 'block' }}>
                                    Indica si la ubicación está activa y puede ser utilizada en el sistema
                                </Typography>
                                <Controller
                                    control={control}
                                    name="enabled"
                                    render={({ field }) => (
                                        <Switch 
                                            checked={location.enabled} 
                                            onChange={(e) => handleFieldChange('enabled', e.target.checked)}
                                        />
                                    )}
                                />
                            </Grid>

                        </Grid>
                    </Box>
                </Box>
            </form>

            <Backdrop open={loadingCreateLocation}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <Typography variant="h6" sx={{ color: theme.palette.text.primary }}>
                        Creando ubicación...
                    </Typography>
                    <CircularProgress />
                </Box>
            </Backdrop>

            {
                loadingGetLocationByHash && (
                    <Backdrop open={loadingGetLocationByHash}>
                        <Typography variant="h6" sx={{ color: theme.palette.text.primary }}>
                            Cargando ubicación...
                        </Typography>
                        <CircularProgress />
                    </Backdrop>
                )
            }
        </Container >
    ) 
}